import { applyDocumentLocale } from '@/lib/locale-direction';
import { type Language, persistUserLanguage } from '@/lib/language-prefs';

/** Applique la langue UI (localStorage, document, i18n) sans toucher aux stores. */
export function applyAppLanguage(language: Language, opts?: { persist?: boolean }): void {
  const persist = opts?.persist !== false;
  if (persist) persistUserLanguage(language);
  applyDocumentLocale(language);
  if (typeof window !== 'undefined' && (window as { __i18n?: { changeLanguage: (l: string) => Promise<unknown> } }).__i18n) {
    void (window as { __i18n: { changeLanguage: (l: string) => Promise<unknown> } }).__i18n.changeLanguage(language);
  }
}
